import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';

import { ReportsRoutingModule, routableModules  } from './reports-routing.module';
import { ReportsComponent } from './reports.component';
import { GdsUsageReportModule } from './gds-usage-report/gds-usage-report.module';
import { RateAuditSummaryReportModule } from './rate-audit-summary-report/rate-audit-summary-report.module';
import { FailedEmailNotificationsModule } from './failed-email-notifications/failed-email-notifications.module';

@NgModule({
  imports: [
    CommonModule
    ,ReportsRoutingModule
    ,LayoutModule
    ,routableModules, FailedEmailNotificationsModule
  ],
  declarations: [ReportsComponent],
  exports: [ReportsComponent]
})
export class ReportsModule { }
